import React, { useState } from "react";
import ConfirmationModal from "../../../views/Inventory/Items/ConfirmationModal/ConfirmationModal";
import ConfirmationModalWithValue from "../../../views/Inventory/Items/ConfirmationModal/ConfirmationModalWithValue";
import {
  buttonNameConstants,
  EMPTY_STRING,
  modalConstants,
  transactionConstants,
} from "../../../constants";
import {
  getReceiptPrintDate,
  getTotalAmountFromTransaction,
  getTotalQuantityOfTransaction,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";

const VoidTransactionModal = (props) => {
  const {
    show,
    onHide,
    transaction,
    user,
    onSubmitVoid,
    showDetails = false,
  } = props;

  const [showReasonModal, setShowReasonModal] = useState(false);

  const handleConfirmVoid = () => {
    setShowReasonModal(true);
  };

  const handleSubmitVoid = (reasonValue) => {
    const dataToSend = {
      isVoided: true,
      transactionId: transaction?.id,
      storeId: transaction?.store?.id,
      voidReason: reasonValue || "",
      voidedBy: {
        id: user?.id,
        name: `${user?.firstName} ${user?.lastName}`,
      },
    };
    onSubmitVoid(dataToSend);
    handleCloseAll();
  };

  const handleCloseAll = () => {
    onHide();
    setShowReasonModal(false);
  };

  const handleCancel = () => {
    setShowReasonModal(false);
  };

  return (
    <>
      <ConfirmationModal
        title={
          showDetails ? buttonNameConstants.VOID_TRANSACTION : EMPTY_STRING
        }
        isConfirmationModal={show}
        toggleConfirmationModal={handleCloseAll}
        handleNoButtonClick={handleCloseAll}
        handleYesButtonClick={handleConfirmVoid}
        message={transactionConstants.VOID_CONFIRMATION_MESSAGE}
        rootColumnClassName={"p-0"}
        headerClassName={"px-4"}
        headerTitleTextClassName={"modal-sale-transaction-id"}
        bodyClassName={"px-4"}
      >
        {showDetails && transaction && (
          <div className="d-flex flex-column gap-2 mb-3 mt-3">
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Transaction ID:</span>
              <span>{transaction?.id}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Date:</span>
              <span>{getReceiptPrintDate(transaction?.createdOn)}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Transaction Type:</span>
              <span className="text-capitalize">{transaction?.type}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Cart Quantity:</span>
              <span>
                {transaction?.cartQuantity ||
                  getTotalQuantityOfTransaction(transaction)}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="fw-bold">Total Amount:</span>
              <span>
                $
                {parseToThousandSeperatorDecimalNumber(
                  getTotalAmountFromTransaction(transaction)
                )}
              </span>
            </div>
          </div>
        )}
      </ConfirmationModal>

      <ConfirmationModalWithValue
        isConfirmationModal={showReasonModal}
        toggleConfirmationModal={handleCancel}
        handleNoButtonClick={handleCancel}
        handleYesButtonClick={handleSubmitVoid}
        noButtonText={buttonNameConstants.CANCEL}
        yesButtonText={buttonNameConstants.VOID}
        showInput={true}
        inputLabel={transactionConstants.VOID_REASON_LABEL}
        inputPlaceholder={"Enter reason"}
        fieldName={transactionConstants.VOID_REASON_FIELD_NAME}
        title={buttonNameConstants.VOID_TRANSACTION}
        type={modalConstants.TEXT_AREA_INPUT_FIELD}
        isOptional={true}
      />
    </>
  );
};

export default VoidTransactionModal;
